import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=4c26db3c&"
import script from "./BaseTextArea.vue?vue&type=script&lang=js&"
export * from "./BaseTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c26db3c')) {
      api.createRecord('4c26db3c', component.options)
    } else {
      api.reload('4c26db3c', component.options)
    }
    module.hot.accept("./BaseTextArea.vue?vue&type=template&id=4c26db3c&", function () {
      api.rerender('4c26db3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BaseTextArea.vue"
export default component.exports